import { Box, Paragraph, Text } from '@zillow/constellation-10';
import MoveInCostsTypes from '@common/constants/MoveInCostsConstants';
import { MoveInCostsItems } from '@renter-hub/models/Types';
import { centsToDollars } from '@common/paymentsUtils/currencyUtils';

interface Props {
  zgFee: number;
  totalAmount: number;
  items: MoveInCostsItems[];
}

const MoveInCostsItemsDisplay = ({ zgFee, totalAmount, items }: Props) => {
  const showCardFee = zgFee !== 0;
  return (
    <>
      {items.map((moveInCostItem, i) => (
        <Box
          key={`moveInCosts${i}`}
          css={{
            display: 'grid',
            gridTemplateColumns: '9fr 3fr',

            marginBottom: 'token(spacing.xs) !important',
          }}
        >
          <Box>
            <Paragraph textStyle="body-bold">
              {moveInCostItem.subType || MoveInCostsTypes[moveInCostItem.type]}
            </Paragraph>
            <Paragraph color="text.subtle" textStyle="body-sm">
              {moveInCostItem.notes}
            </Paragraph>
          </Box>
          <Box css={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Text>{centsToDollars(moveInCostItem.amount)}</Text>
          </Box>
        </Box>
      ))}
      {showCardFee && (
        <Box css={{ display: 'grid', gridTemplateColumns: '9fr 3fr' }} className="fs-exclude">
          <Paragraph textStyle="body-bold">Card fee</Paragraph>
          <Box css={{ textAlign: 'right' }}>
            <Text>{centsToDollars(zgFee)}</Text>
          </Box>
        </Box>
      )}
      <Box
        css={{ display: 'grid', gridTemplateColumns: '9fr 3fr', marginTop: 'token(spacing.sm) !important' }}
        className="fs-exclude"
      >
        <Paragraph textStyle="body-bold">Total payment</Paragraph>
        <Box css={{ textAlign: 'right' }}>
          <Text textStyle="body-bold">{centsToDollars(totalAmount)}</Text>
        </Box>
      </Box>
    </>
  );
};

export default MoveInCostsItemsDisplay;
